import { TokenStoreProvider } from "@redriver/cinnamon-core";

const storeToken = async (key: string, token: string) => {
  sessionStorage.setItem(key, token);
};

const getToken = async (key: string) => {
  return sessionStorage.getItem(key);
};

const clearToken = async (key: string) => {
  sessionStorage.removeItem(key);
};

export const SessionTokenStoreProvider: TokenStoreProvider = {
  storeToken,
  getToken,
  clearToken,
};
